module.exports = __webpack_public_path__ + "img/horizontal_6_3_5010.425c7224.png";